(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  // Funkcja kopiowania numeru konta bankowego
  function copyBankAccount(element, accountNumber) {
    // Usuń wszystkie spacje z numeru konta
    const cleanNumber = accountNumber.replace(/\s+/g, '');
    
    // Skopiuj do schowka
    navigator.clipboard.writeText(cleanNumber).then(function() {
      // Pokaż powiadomienie
      const originalText = element.innerHTML;
      element.innerHTML = '✓ Skopiowano!';
      element.style.color = '#4CAF50';
      
      // Przywróć oryginalny tekst po 2 sekundach
      setTimeout(function() {
        element.innerHTML = originalText;
        element.style.color = '';
      }, 2000);
    }).catch(function(err) {
      console.error('Błąd kopiowania: ', err);
      alert('Nie udało się skopiować numeru konta');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naglowek"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setupModernHeader();
    }

    setupModernHeader() {
      this.raf = null;
      this.ticking = false;
      this.lastScrollY = window.scrollY;
      this.scrollDirection = 'up';
      this.headerObserver = null;
      this.setupIntersectionObserver();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.addModernEnhancements();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.modernOnScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    addModernEnhancements() {
      document.documentElement.style.scrollBehavior = 'smooth';
      this.setupModernFocus();
      this.header.style.willChange = 'transform, backdrop-filter';
    }

    setupModernFocus() {
      const focusableElements = this.querySelectorAll('a, button, summary, input');
      focusableElements.forEach(el => {
        el.addEventListener('focus', this.enhanceFocus.bind(this));
        el.addEventListener('blur', this.removeFocus.bind(this));
      });
    }

    enhanceFocus(e) {
      e.target.style.transform = 'translateY(-2px)';
      e.target.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.15)';
    }

    removeFocus(e) {
      e.target.style.transform = '';
      e.target.style.boxShadow = '';
    }

    setupIntersectionObserver() {
      if ('IntersectionObserver' in window) {
        this.headerObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.header?.classList.remove('scrolled-past-header');
            } else {
              this.header?.classList.add('scrolled-past-header');
            }
          });
        }, { threshold: 0.1 });
      }
    }

    setHeaderHeight() {
      const height = this.header?.offsetHeight || 70;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.headerObserver?.disconnect();
      
      if (this.raf) {
        cancelAnimationFrame(this.raf);
      }
    }

    createObserver() {
      if (!('IntersectionObserver' in window)) return;
      
      let observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      }, { threshold: 0 });

      observer.observe(this.header);
    }

    modernOnScroll() {
      if (!this.ticking) {
        this.raf = requestAnimationFrame(() => {
          this.updateHeader();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    updateHeader() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      this.scrollDirection = scrollTop > this.lastScrollY ? 'down' : 'up';
      this.lastScrollY = scrollTop;

      if (this.predictiveSearch?.isOpen) return;

      document.documentElement.style.setProperty('--scroll-progress', 
        Math.min(scrollTop / (this.headerBounds.bottom || 100), 1));

      if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom || 100)) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventHide) {
          this.modernHide();
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom || 100)) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.modernReveal();
        } else {
          this.delayedHide();
        }
      } else if (scrollTop <= (this.headerBounds.top || 0)) {
        this.header.classList.remove('scrolled-past-header');
        this.modernReset();
      }

      this.currentScrollTop = scrollTop;
    }

    modernHide() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.style.transform = 'translateY(-100%)';
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    modernReveal() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.style.transform = 'translateY(0)';
    }

    modernReset() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.header.style.transform = '';
    }

    delayedHide() {
      window.clearTimeout(this.isScrolling);
      this.isScrolling = setTimeout(() => {
        this.preventReveal = false;
      }, 100);
      this.modernHide();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();
      this.addModernEnhancements();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    addModernEnhancements() {
      this.header.style.willChange = 'auto';
      this.setupAccessibility();
    }

    setupAccessibility() {
      const menuItems = this.querySelectorAll('.header__menu-item');
      menuItems.forEach((item, index) => {
        item.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' && menuItems[index + 1]) {
            menuItems[index + 1].focus();
          } else if (e.key === 'ArrowLeft' && menuItems[index - 1]) {
            menuItems[index - 1].focus();
          }
        });
      });
    }

    setHeaderHeight() {
      const height = this.header?.offsetHeight || 70;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  if ('performance' in window && 'PerformanceObserver' in window) {
    const perfObserver = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      entries.forEach(entry => {
        if (entry.entryType === 'paint' && entry.name === 'first-contentful-paint') {
          console.log(`Header FCP: ${entry.startTime}ms`);
        }
      });
    });
    
    try {
      perfObserver.observe({ entryTypes: ['paint'] });
    } catch (e) {
      // Graceful fallback
    }
  }

  } catch(e) { console.error(e); }
})();
})();
